//#region Libraries
import styled, { keyframes } from "styled-components";
//#endregion

const animation = keyframes`
    to {
        filter: brightness(105%);
    }
`;
export const EmptyLabel = styled.div`
    background-color: var(--light-blue-1);
    border-radius: 4px;
    margin: 1px;
    width: ${({ width = "135px" }) => width};
    height: ${({ height = "12px" }) => height};
    animation: linear ${animation} 0.7s alternate-reverse infinite;
`;
export const Header = styled.h4`
    display: grid;
    place-items: center;
`;